"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayTransactionsResponseSchema = exports.GatewayTransactionsKpisSchema = exports.GatewayTransactionSchema = void 0;
const zod_1 = require("zod");
/** A single transaction as seen at the payment gateway, optionally matched
 *  against the POS record. `source` is 'nmi' (live NMI Query API), 'dejavoo'
 *  (recorded terminal payments reconciled to POS), or 'cash' (reserved). */
exports.GatewayTransactionSchema = zod_1.z.object({
    source: zod_1.z.enum(['nmi', 'dejavoo', 'cash']).default('nmi'),
    gatewayTxnId: zod_1.z.string(),
    orderId: zod_1.z.string().optional(),
    occurredAt: zod_1.z.string().optional(), // ISO 8601; displayed browser-local
    amount: zod_1.z.number(),
    currency: zod_1.z.string().default('USD'),
    cardBrand: zod_1.z.string().optional(),
    last4: zod_1.z.string().optional(),
    authCode: zod_1.z.string().optional(),
    type: zod_1.z.string().optional(), // sale | auth | capture | refund | void
    status: zod_1.z.enum(['complete', 'pending', 'failed', 'voided', 'refunded', 'unknown']),
    // NMI settlement state, derived from `condition`: complete→settled,
    // pendingsettlement→unsettled, everything else→na. Optional so older
    // producers/consumers stay compatible.
    settlement: zod_1.z.enum(['settled', 'unsettled', 'na']).optional(),
    matchStatus: zod_1.z.enum(['matched', 'gateway_only', 'pos_only']),
    posPaymentId: zod_1.z.string().optional(),
    posStatus: zod_1.z.string().optional(),
    // ─── Dejavoo reconciliation (source='dejavoo' only; optional so the NMI
    //     producer/consumer are unaffected) ─────────────────────────────────
    // Per-payment reconciliation vs the POS sale it belongs to:
    //   matched          → sale found, amounts agree
    //   missing_in_pos    → card charged but NO sale recorded (orphan to chase)
    //   amount_mismatch   → sale found but card charged a different total
    //   refunded          → this leg was refunded
    //   pos_only          → a POS Dejavoo leg with no matching payment record
    reconciliation: zod_1.z.enum(['matched', 'missing_in_pos', 'amount_mismatch', 'refunded', 'pos_only']).optional(),
    posAmount: zod_1.z.number().optional(), // amount recorded on the POS sale
    posTransactionNumber: zod_1.z.string().optional(), // human sale # for display
    terminalId: zod_1.z.string().optional(), // EMV device / TPN owner
});
exports.GatewayTransactionsKpisSchema = zod_1.z.object({
    count: zod_1.z.number(),
    gross: zod_1.z.number(),
    matched: zod_1.z.number(),
    gatewayOnly: zod_1.z.number(),
    posOnly: zod_1.z.number(),
    // Gateway-side outcome totals (by NMI condition). Defaulted so older
    // producers/consumers stay compatible.
    voidedCount: zod_1.z.number().default(0),
    voidedAmount: zod_1.z.number().default(0),
    failedCount: zod_1.z.number().default(0),
    failedAmount: zod_1.z.number().default(0),
    refundedCount: zod_1.z.number().default(0),
    refundedAmount: zod_1.z.number().default(0),
    settledCount: zod_1.z.number().default(0),
    unsettledCount: zod_1.z.number().default(0),
    unsettledAmount: zod_1.z.number().default(0),
    // Dejavoo reconciliation KPIs (default 0 so NMI payloads are unaffected).
    missingInPosCount: zod_1.z.number().default(0),
    missingInPosAmount: zod_1.z.number().default(0),
    amountMismatchCount: zod_1.z.number().default(0),
});
exports.GatewayTransactionsResponseSchema = zod_1.z.object({
    source: zod_1.z.enum(['nmi', 'dejavoo', 'cash']).default('nmi'),
    locationId: zod_1.z.string(),
    from: zod_1.z.string(), // YYYY-MM-DD (store-local calendar day)
    to: zod_1.z.string(), // YYYY-MM-DD
    rows: zod_1.z.array(exports.GatewayTransactionSchema),
    kpis: exports.GatewayTransactionsKpisSchema,
});
//# sourceMappingURL=gateway-transaction.schema.js.map